import { FC, HTMLAttributes, ReactNode } from "react";

import HtmlText from "../common/HtmlText";
import clsx from "clsx";

// --------------------------------------------------------------------------------

export type IScheduleCard = {
  heading?: string;
  description?: ReactNode;
};

export type ICourseTimingSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  scheduleCards?: IScheduleCard[];
};

const CourseTimingSection: FC<ICourseTimingSectionProps> = (props) => {
  const { heading, description, scheduleCards, className, ...other } = props;

  return (
    <section
      className={clsx("py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="dark:bg-black-800">
        <div className="container py-10 lg:py-16 xl:py-[100px]">
          {heading && (
            <h2 className="mb-5 w-full text-3xl font-medium text-black-900 dark:text-white lg:mb-7 lg:text-h2">
              {heading}
            </h2>
          )}

          {description && (
            <HtmlText className="mb-5 lg:mb-7">{description}</HtmlText>
          )}

          {scheduleCards && scheduleCards.length > 0 && (
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:gap-7">
              {scheduleCards.map((item, idx) => (
                <div
                  key={idx}
                  className="h-full w-full p-px dark:bg-gradient-to-r dark:from-primary-900 dark:to-white"
                >
                  <div
                    key={idx}
                    className="flex h-full gap-5 bg-primary-100 bg-gradient-to-r p-5 dark:bg-black-800 dark:from-primary-900/50 dark:to-primary-900/10 md:gap-7 md:p-8 lg:gap-10 lg:p-12 lg:pt-9 xl:gap-12"
                  >
                    <div>
                      <h2 className="text-3xl font-medium text-yellow-400 lg:text-h2">
                        {idx + 1}.
                      </h2>
                    </div>
                    <div className="flex flex-col gap-4 lg:gap-5">
                      <h6 className="text-base font-normal text-black-900 dark:text-white md:mt-2 lg:text-h6">
                        {item.heading}
                      </h6>
                      <div className="flex flex-col gap-4">
                        {item.description && (
                          <HtmlText>{item.description}</HtmlText>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CourseTimingSection;
